// Inline SVG bottle illustration tinted by category color.
// No external image dependency — clean, consistent on all devices.
const ProductBottle = ({ color = '#1f3d2b', size = 140 }) => (
  <svg
    viewBox="0 0 100 140"
    width={size}
    height={(size * 140) / 100}
    aria-hidden="true"
  >
    {/* cap */}
    <rect x="34" y="6" width="32" height="14" rx="3" fill={color} opacity="0.85" />
    <rect x="34" y="6" width="32" height="4" rx="2" fill={color} />
    {/* neck */}
    <rect x="40" y="20" width="20" height="8" fill={color} opacity="0.4" />
    {/* body */}
    <rect
      x="22"
      y="28"
      width="56"
      height="100"
      rx="10"
      fill={color}
      opacity="0.12"
      stroke={color}
      strokeWidth="2"
    />
    {/* label */}
    <rect x="28" y="56" width="44" height="48" rx="3" fill="white" />
    <rect x="32" y="62" width="36" height="3" rx="1.5" fill={color} />
    <rect x="32" y="70" width="28" height="2" rx="1" fill={color} opacity="0.5" />
    <rect x="32" y="76" width="32" height="2" rx="1" fill={color} opacity="0.5" />
    <circle cx="50" cy="92" r="6" fill={color} opacity="0.85" />
  </svg>
);

export default ProductBottle;
